module.exports = __webpack_public_path__ + "static/media/google-calendar.c48031fc.svg";